import { render, staticRenderFns } from "./studentsModal.vue?vue&type=template&id=b6f95c8c&"
import script from "./studentsModal.vue?vue&type=script&lang=js&"
export * from "./studentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports